import Backbone from 'backbone'
import _ from 'lodash'
import template from './mass-edit-response.hbs'
import i18n from 'scoreboard/components/i18n'
import formatValue from 'scoreboard/components/format-value'
import DataType from 'scoreboard/datasets/model/data-type'
const { NUMBER } = DataType

var MassEditResponse = Backbone.View.extend({

	initialize: function(options = {}) {
		this.data = options.data
	},

	render: function () {
		this.$el.append(template(this.context()))
		return this
	},

	context: function() {
		var updatedNodeIds = this.data.updatedItemIds
		var numberUpdated = _.size(updatedNodeIds)
		var key = 'report.customReport.massedit.modified.' +
			(numberUpdated === 1 ? 'singular' : 'plural')
		let formatted = formatValue({
			value: numberUpdated,
			dataType: NUMBER,
			shorten: false
		})
		var message = i18n.get(key, formatted)
		var reasons = []

		let errors = (scorecardItemLabels, key, errorTypeCode) => {
			var reason = {}
			reason.labels = []
			// remove any ending period
			let msg = _.trimEnd(key, '.')
			// lowercase the first letter, unless it starts with 'SIPR' (#41691)
			if (!_.startsWith(msg, 'SIPR')) {
				msg = _.lowerFirst(msg)
			}
			reason.message = i18n.get(errorTypeCode, msg)

			var numLabels =  _.size(scorecardItemLabels)
			var numDisplay = 3
			var more = numLabels - numDisplay
			// if we only have "1 more..." after the initial 3 display,
			// just go ahead and show it so it doesn't look weird
			if (more === 1) {
				numDisplay++
			}
			var moreMsg = i18n.get('report.customReport.massedit.more', more)
			var displayLabels = _.take(scorecardItemLabels, numDisplay)

			_.each(displayLabels, function(val) {
				reason.labels.push(val)
			})

			if (more > 1) {
				reason.labels.push(moreMsg)
			}
			reasons.push(reason)
		}

		_.each(this.data.partialItemMessages, _.partial(errors, _, _, 'report.customReport.massedit.partiallyModifiedReason'))
		_.each(this.data.skippedItemMessages, _.partial(errors, _, _, 'report.customReport.massedit.notModifiedReason'))

		// #40701 display a message when editing weights to let the user know that
		// the new percent weightings won't necessarily be ready right away.
		// (note: data.weights is added to the data returned by the endpoint
		// in the mass-edit-form.js submit method)
		let displayWeightMessage = false
		if (numberUpdated > 0 && !_.isNil(this.data.weights)) {
			displayWeightMessage = true
		}

		return {
			message,
			reasons,
			displayWeightMessage
		}
	},

	scrollTo: function () {
		this.el.scrollIntoView(false)
	}

})

export default MassEditResponse

MassEditResponse.__filename__ = 'admin/mass-edit/mass-edit-response.js'
